// This import loads the firebase namespace along with all its type information.
import MediaReactions from './media-reactions-model'

export async function load_mediaReactionss(): Promise<MediaReactions[]> {
  throw 'Not implemented'
}

export async function delete_mediaReactions(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaReactions(): Promise<MediaReactions> {
  throw 'Not implemented'
}
